/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#interactive.viewport{position:relative;width:100%;height:auto;overflow:hidden;text-align:center}#interactive.viewport canvas,#interactive.viewport video{max-width:100%;width:100%}#interactive.viewport canvas.drawing,#interactive.viewport canvas.drawingBuffer{position:absolute;left:0;top:0}"];
export { styles as styles };
